import { z } from "zod/v4";

export const GetShippingCarriersResponseBodySchema = z
  .object({
    id: z.number(),
    active: z.boolean(),
    carrier_service_type: z.string(),
    admin_graphql_api_id: z.string(),
    format: z.string().nullish(),
  })
  .array();

export type GetShippingCarriersResponseBodyType = z.infer<
  typeof GetShippingCarriersResponseBodySchema
>;
